module.exports = __webpack_public_path__ + "static/media/knoxwire.ca46d08b.jpg";